import { toast, useErrorMessage } from '@sentinel/web-core';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { consoleEndpoints } from '@/api/endpoints';
import { keys } from '@/api/keys';

/** The support windows asked by this platform person, and the organizations to ask. */
export function useSupport() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const errorMessage = useErrorMessage();
  const onError = (error: unknown) => toast('att', errorMessage(error));
  const refresh = () => void queryClient.invalidateQueries({ queryKey: keys.support });

  const grants = useQuery({ queryKey: keys.support, queryFn: consoleEndpoints.supportRequests });
  const organizations = useQuery({
    queryKey: keys.organizations,
    queryFn: consoleEndpoints.organizations,
  });
  const request = useMutation({
    mutationFn: (input: { organizationId: string; reason: string }) =>
      consoleEndpoints.requestSupport(input.organizationId, input.reason),
    onSuccess: () => {
      toast('ok', t('console.support.requested'), t('console.support.requestedDetail'));
      refresh();
    },
    onError,
  });
  const close = useMutation({
    mutationFn: (grantId: string) => consoleEndpoints.closeSupport(grantId),
    onSuccess: () => {
      toast('ok', t('console.support.closed'));
      refresh();
    },
    onError,
  });
  return { grants, organizations, request, close };
}
